import { c as _c } from "react/compiler-runtime";
import { IS_CI, IS_E2E, IS_PROD, IS_SERVER, IS_TEST } from '@onefootprint/dev-tools';
import type { OnboardingSessionConfig } from '@onefootprint/request-types';
import { useEffect } from 'react';
import nid from '../utils/neuro-id';
const NID_LIVE_SITE_NAME = 'humor717';
const NID_DEV_SITE_NAME = 'humor717-test';
const IS_DISABLED_BY_ENV = IS_SERVER || IS_TEST || IS_E2E || IS_CI;
type LoadNeuroIdProps = {
  config?: OnboardingSessionConfig;
};
const LoadNeuroId = t0 => {
  const $ = _c(8);
  const {
    config
  } = t0;
  const isEnabled = !IS_DISABLED_BY_ENV && config?.nidEnabled;
  const siteName = IS_PROD && config?.isLive ? NID_LIVE_SITE_NAME : NID_DEV_SITE_NAME;
  let t1;
  if ($[0] !== config || $[1] !== isEnabled || $[2] !== siteName) {
    t1 = () => {
      if (!isEnabled) {
        return;
      }
      const src = `//scripts.neuro-id.com/c/nid-${siteName}.js`;
      const existing = document.querySelector(`script[src="${src}"]`);
      if (existing) {
        return;
      }
      const script = document.createElement("script");
      script.id = "neuro-id-script";
      script.src = src;
      script.async = true;
      script.onload = () => {
        if (config?.orgId) {
          nid.setVariable("funnel", config.orgId);
        }
      };
      script.onerror = _temp;
      document.body.appendChild(script);
    };
    $[0] = config;
    $[1] = isEnabled;
    $[2] = siteName;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = config?.orgId;
  let t3;
  if ($[4] !== isEnabled || $[5] !== siteName || $[6] !== t2) {
    t3 = [isEnabled, siteName, t2];
    $[4] = isEnabled;
    $[5] = siteName;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  useEffect(t1, t3);
  return null;
};
export default LoadNeuroId;
function _temp(e) {
  const message = e instanceof Event ? "Unknown error" : String(e);
  console.warn(`Failed to load the Neuro-ID script: ${message}`);
}